export default __webpack_public_path__ + "static/media/first-bet-ico.b42a3b86.svg";